import type { PixelEventName, StorefrontEventContent } from '@xshop/shared';

// Everything a vendor tag can be told about one funnel step. eventId is the deduplication key
// the server dispatch reuses verbatim: without it the platform counts the same conversion twice.
export interface PixelPayload {
  eventId: string;
  value?: number;
  currency?: string;
  contentId?: string;
  orderId?: string;
  /** The order's number as the shop shows it, the order_id the server's copy sends too. */
  orderNumber?: string;
  numItems?: number;
  /** Every product in the event, with its quantity and the price of one. */
  contents?: StorefrontEventContent[];
  contentName?: string;
}

/** Who the browser is to the ad platforms: the id its events are matched on. */
export type PixelIdentity = { externalId: string };

// One ad platform's browser tag, as the orchestrator drives it.
export interface BrowserPixel {
  install: (ids: string[], identity: PixelIdentity) => void;
  track: (event: PixelEventName, payload: PixelPayload) => void;
}

// Adds a vendor script tag once; a second call with the same id is a no-op, not a second load.
export function injectScript(src: string, id: string): void {
  if (typeof document === 'undefined' || document.getElementById(id)) return;
  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

// Returns the shared Google dataLayer, creating it when no Google tag has run yet.
export function dataLayer(): unknown[] {
  const target = window as Window & { dataLayer?: unknown[] };
  target.dataLayer ??= [];
  return target.dataLayer;
}
